import request from '@/utils/request'

export function getProductList(data) {
  return request.post('/product/list', data)
}



// WEBPACK FOOTER //
// ./src/api/product.js